<template>
  <footer class="footer main-row">
    <div class="footer-body col col-xlg-12 col-lg-12 col-sm-12">
      <div>中国科学院昆明植物研究所</div>
      <div>备案序号： 【滇ICP备05000394号】</div>
      <div>本数据库由云南省科技厅科技计划项目、中国科学院科学数据中心体系建设项目支持。</div>
      <div>邮政编码：650201</div>
      <div>联系地址：云南省昆明市盘龙区蓝黑路132号</div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "homeFooter"
}
</script>

<style scoped lang="scss">
.footer {
  display:table;
  z-index: 0;
  width: 100%;
  height: 180px;
  //margin-top: 120px;
  .footer-body {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    color: #fff;
    background-color: #808080FF;
    height: 180px;
    padding: 5px 0;
    font-size: 16px;
  }
}
@media screen and (max-width: 1200px){
  .footer {
    width: 100%;
    .footer-body {
      font-size: 16px !important;
    }
  }
}
@media screen and (max-width: 992px) {
  .footer {
    width: 100%;
    .footer-body {
      font-size: 16px !important;
    }
  }
}
@media screen and (max-width: 768px) {
  .footer {
    width: 100%;
    .footer-body {
      font-size: 16px !important;
    }
  }
}
@media screen and (max-width: 576px) {
  .footer {
    width: 100%;
    .footer-body {
      padding: 5px;
      font-size:16px !important;
    }
  }
}
@media screen and (max-width: 375px) {
  .footer {
    width: 100%;
    .footer-body {
padding: 5px;
      font-size: 0.373rem !important;
    }
  }
}
</style>